class Video {
  constructor(params) {
    this.youtubeId = params.youtubeId;
  }
}

export { Video };



// WEBPACK FOOTER //
// ./src/models/Video.js